// import { Autoplay, Swiper } from 'swiper'
// Swiper.use([Autoplay]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  // TOPページの処理
  // initMVTextAnimation()
  initTopAboutImageHover()
  initTopAboutMobileSlider()
  initSecQA()
}

initSecCTASlider()
initParallax()

/**
 * MV Section: "It's so you." テキストアニメーション制御
 * aboutセクションに到達するまで固定表示、到達後は固定を解除
 */
function initMVTextAnimation() {
  const secMVTextAnimation = document.querySelector('.secMV__text-animation')
  const aboutSection = document.querySelector('#about')

  if (!secMVTextAnimation || !aboutSection) {
    return
  }

  const checkScroll = () => {
    const aboutRect = aboutSection.getBoundingClientRect()
    const windowHeight = window.innerHeight

    // aboutセクションが画面内に入ったら固定を解除
    if (aboutRect.top <= windowHeight) {
      secMVTextAnimation.classList.add('is-stopped')
    } else {
      secMVTextAnimation.classList.remove('is-stopped')
    }
  }

  // スクロールイベントを最適化（throttle）
  let ticking = false
  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkScroll()
        ticking = false
      })
      ticking = true
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true })
  checkScroll() // 初回実行
}

/**
 * About Section: リンクホバー時の画像切り替え
 */
function initTopAboutImageHover() {
  const topAboutSection = document.querySelector('.topAbout')
  if (!topAboutSection) {
    return
  }

  const links = topAboutSection.querySelectorAll('.topAbout__link[data-image]')
  const images = topAboutSection.querySelectorAll('.topAbout__img[data-image]')

  if (links.length === 0 || images.length === 0) {
    return
  }

  // 初期状態：最初の画像にactiveクラスを追加
  const defaultImage = topAboutSection.querySelector('.topAbout__img[data-image="about-1"]')
  if (defaultImage) {
    // defaultImage.classList.add('topAbout__img--active')
  }

  links.forEach((link) => {
    const hoveredImageType = link.getAttribute('data-image')

    link.addEventListener('mouseenter', () => {
      images.forEach((img) => {
        const imageType = img.getAttribute('data-image')

        if (imageType === hoveredImageType) {
          img.classList.add('topAbout__img--active')
        } else {
          img.classList.remove('topAbout__img--active')
        }
      })
    })
  })

  const linksContainer = topAboutSection.querySelector('.topAbout__links')
  if (linksContainer) {
    linksContainer.addEventListener('mouseleave', () => {
      // すべての画像からactiveクラスを削除
      images.forEach((img) => {
        img.classList.remove('topAbout__img--active')
      })

      // デフォルトの画像（最初の画像）にactiveクラスを追加
      if (defaultImage) {
        // defaultImage.classList.add('topAbout__img--active')
      }
    })
  }
}

/**
 * About Section: モバイル用スライダー
 */
function initTopAboutMobileSlider() {
  const topAboutSection = document.querySelector('.topAbout')
  if (!topAboutSection) {
    return
  }

  // モバイル（768px以下）
  const isMobile = () => window.innerWidth <= 768

  const images = topAboutSection.querySelectorAll('.topAbout__img[data-image]')
  if (images.length === 0) {
    return
  }

  let currentIndex = 0
  const totalImages = images.length
  const slideInterval = 3000
  let sliderTimer = null

  // 画像を切り替える
  const switchImage = () => {
    // すべての画像からactiveクラスを削除
    images.forEach((img) => {
      img.classList.remove('topAbout__img--active')
    })

    // 現在の画像にactiveクラスを追加
    if (images[currentIndex]) {
      images[currentIndex].classList.add('topAbout__img--active')
    }

    // 次のインデックスに進む
    currentIndex = (currentIndex + 1) % totalImages
  }

  // スライダーを開始
  const startSlider = () => {
    if (sliderTimer) {
      clearInterval(sliderTimer)
    }
    sliderTimer = setInterval(switchImage, slideInterval)
  }

  // スライダーを停止
  const stopSlider = () => {
    if (sliderTimer) {
      clearInterval(sliderTimer)
      sliderTimer = null
    }
  }

  // 初期状態の設定
  const initSlider = () => {
    if (isMobile()) {
      // モバイルの場合：最初の画像をアクティブにしてスライダーを開始
      if (images[0]) {
        images[0].classList.add('topAbout__img--active')
      }
      startSlider()
    } else {
      // PCの場合：スライダーを停止（デスクトップのホバー機能に任せる）
      stopSlider()
      // すべての画像からactiveクラスを削除（デスクトップのホバー機能で管理）
      images.forEach((img) => {
        // img.classList.remove('topAbout__img--active')
      })
    }
  }

  // 初期化
  initSlider()

  // ウィンドウリサイズ時にモバイルを再チェック
  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      initSlider()
    }, 100)
  })
}

/**
 * FAQ Section: アコーディオンの初期化
 */
function initSecQA() {
  const secQA = document.querySelector('.secQA')
  if (!secQA) {
    return
  }

  const questions = secQA.querySelectorAll('.secQA__question')

  questions.forEach((question) => {
    const checkbox = question.previousElementSibling
    if (!checkbox || checkbox.type !== 'checkbox') {
      return
    }
  })
}

/**
 * CTA Section: Join us スライダー
 */
function initSecCTASlider() {
  const ctaSlider = document.querySelector('.secCTA__slider .splide')
  if (!ctaSlider) {
    return
  }

  new Splide(ctaSlider, {
    type: 'loop',
    drag: true,
    gap: '1rem',
    arrows: false,
    pagination: false,
    autoWidth: true,
    breakpoints: {
      1024: {
        perPage: 1,
      },
      768: {
        perPage: 1,
        gap: '1rem',
      },
    },
    autoScroll: {
      speed: 0.4,
      pauseOnHover: false,
    },
  }).mount({ AutoScroll })
}

// Interview Section Splideスライダー
const interviewSplide = document.querySelector('.secInterview__slider .splide')
if (interviewSplide) {
  new Splide(interviewSplide, {
    type: 'loop',
    drag: false,
    autoWidth: true,
    gap: 20,
    arrows: false,
    pagination: false,
    breakpoints: {
      900: {
        autoWidth: false,
        fixedWidth: 100,
        gap: 10,
      },
    },
    autoScroll: {
      speed: 0.8,
      pauseOnHover: false,
    },
  }).mount({ AutoScroll })
}

//画像に適用されたblur-animeクラスをアニメーションさせる
const blurAnimeItems = document.querySelectorAll('.blur-anime')

if (blurAnimeItems.length > 0) {
  blurAnimeItems.forEach((item) => {
    gsap.set(item, { autoAlpha: 0, filter: 'blur(20px)' })
  })

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // delay1, delay2, delay3,...
          let delayTime = 0
          const classList = Array.from(entry.target.classList)
          const delayClass = classList.find((cls) => cls.startsWith('delay'))

          if (delayClass) {
            const delayNumber = parseInt(delayClass.replace('delay', ''))
            if (!isNaN(delayNumber)) {
              // delay1 = 0.1s, delay2 = 0.2s, delay3 = 0.3s,...
              delayTime = delayNumber * 0.1
            }
          }

          gsap.to(entry.target, {
            autoAlpha: 1,
            filter: 'blur(0px)',
            duration: 1.2,
            delay: delayTime,
            ease: 'power2.out',
          })
          obs.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.2 }
  )

  blurAnimeItems.forEach((item) => observer.observe(item))
}

/**
 * Parallax
 */
function initParallax() {
  const parallaxElements = document.querySelectorAll('.js-parallax')

  if (parallaxElements.length === 0) {
    return
  }

  parallaxElements.forEach((element) => {
    gsap.to(element, {
      scrollTrigger: {
        trigger: element,
        start: 'top bottom+=80',
        onUpdate: (self) => {
          const progress = self.progress
          element.style.setProperty('--parallax-progress', progress)
        },
      },
    })
  })
}
